(function () {
  'use strict';

  /* Dawn's filter/sort AJAX update (facets.js renderProductGridContainer) does
     `#ProductGridContainer.innerHTML = ...`, which destroys and recreates the
     #product-grid node entirely. A MutationObserver attached to that node
     stops working the moment it's replaced — it's now watching a detached
     node nobody mutates anymore. #ProductGridContainer itself is never
     replaced (only its contents are), so that's the stable node to observe. */
  var SEL_GRID   = '#ProductGridContainer';
  var SEL_CARD   = '.bc-pcard';
  var SEL_FOOTER = '.bc-pcard__footer';
  var SEL_LINK   = '.bc-pcard__media-wrap';
  var SEL_ATC    = '.bc-pcard__atc';

  function getHandleFromCard(card) {
    var link = card.querySelector(SEL_LINK);
    if (!link) return null;
    var href = (link.getAttribute('href') || '').split('?')[0];
    if (href.endsWith('/')) href = href.slice(0, -1);
    return href.split('/').pop() || null;
  }

  function createAmzBtn(country, url) {
    var cfg = window.amzConfig || {};
    var isUA = country === 'UA';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'amz-card-btn';
    if (isUA) btn.className += ' buy-on-amazon-btn--stameski';

    if (isUA) {
      btn.textContent = cfg.textOnButtonUkraine || 'Купити на Stameski';
    } else if (cfg.logoUrl) {
      btn.innerHTML = 'Buy on <img class="amz-logo" src="' + cfg.logoUrl + '" alt="amazon" width="50" height="15">';
    } else {
      btn.textContent = cfg.textOnButton || 'Buy on Amazon';
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.open(url, '_blank');
    }, true);

    return btn;
  }

  function processCard(card, setItems, country) {
    if (card.dataset.amzDone) return;

    var handle = getHandleFromCard(card);
    if (!handle) return;

    var item = null;
    for (var i = 0; i < setItems.length; i++) {
      if (setItems[i].h === handle) { item = setItems[i]; break; }
    }
    if (!item) return;

    card.dataset.amzDone = '1';

    var footer = card.querySelector(SEL_FOOTER);
    if (!footer) return;

    var mode = item.b || 1;
    var amzBtn = createAmzBtn(country, item.u);

    if (mode === 1) {
      var atc = footer.querySelector(SEL_ATC);
      if (atc) atc.style.display = 'none';
    }

    footer.appendChild(amzBtn);
  }

  function processAllCards(setItems, country) {
    document.querySelectorAll(SEL_CARD).forEach(function (card) {
      processCard(card, setItems, country);
    });
  }

  function init(data) {
    if (!data.set || !data.set.length) return;

    var country = data.country || '';
    if (country !== 'UA') return;
    var setItems = data.set;

    function run() {
      processAllCards(setItems, country);

      var grid = document.querySelector(SEL_GRID);
      if (!grid) return;

      new MutationObserver(function () {
        processAllCards(setItems, country);
      }).observe(grid, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  if (window.amzData) {
    init(window.amzData);
  } else {
    window.addEventListener('amz:ready', function (e) { init(e.detail); }, { once: true });
  }
})();
